import { useState, useEffect } from "react";
import { isMobileDevice } from "../utils/getPlatformInfo";

export const useScrollHandler = (initial = 1000) => {
  const [scrollValue, setScrollValue] = useState(
    isMobileDevice ? -250 : initial * -1
  );
  const scrollOffset = isMobileDevice ? 250 : initial;
  useEffect(() => {
    const onScroll = () => {
      setScrollValue(window.scrollY - scrollOffset);
    };
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [scrollOffset]);
  return scrollValue;
};
